import { Icon } from '../../shared/ui/icon/icon.tsx'
import { useAppModule } from '../appContext.ts'
import { useSnapshot } from 'valtio'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export interface AppleAuthResponse {
  authorization: {
    code: string
    id_token?: string
  }
  user?: {
    name?: { firstName?: string; lastName?: string }
    email?: string
  }
}

const APPLE_REDIRECT_URI = import.meta.env.VITE_APPLE_REDIRECT_URI
const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID

export function AppleAuthButton() {
  const authStore = useAppModule().authStore
  const { loading } = useSnapshot(authStore.state)
  const navigate = useNavigate()

  useEffect(() => {
    window.AppleID.auth.init({
      clientId: APPLE_CLIENT_ID,
      scope: 'name email',
      redirectURI: APPLE_REDIRECT_URI,
      state: 'edman-auth-apple',
      usePopup: true,
    })
  }, [])

  const handleAppleAuth = async () => {
    try {
      await window.AppleID.auth
        .signIn()
        .then(async (response: AppleAuthResponse) => {
          await authStore
            .loginWithApple(response.authorization.code)
            .then(() => {
              navigate('/')
            })
        })
    } catch (err) {
      console.error('Apple Sign-in Error:', err)
    }
  }

  return (
    <button
      onClick={() => {
        void handleAppleAuth()
      }}
      disabled={loading}
      className="flex size-48 cursor-pointer items-center justify-center rounded-24 bg-black"
    >
      <Icon iconName="apple" />
    </button>
  )
}
